import { EventEmitter, Injectable } from '@angular/core';

import { MigrationTabType } from '../../my-bets-base/models/my-bets-viewmodels';
import { MyBetsMigrationTab } from '../models/my-bets-tab';

@Injectable()
export class MyBetsMigrationTabsService {
    private _tabSelected: EventEmitter<MyBetsMigrationTab> = new EventEmitter<MyBetsMigrationTab>();
    migrationTabs: MyBetsMigrationTab[];
    private currentSelectedTab: MyBetsMigrationTab | null = null;

    private beforeTab = new MyBetsMigrationTab(MigrationTabType.Before);
    private afterTab = new MyBetsMigrationTab(MigrationTabType.After);

    private tabTypeToTab = {
        [MigrationTabType.After]: this.afterTab,
        [MigrationTabType.Before]: this.beforeTab,
    };

    constructor() {
        this.migrationTabs = [this.afterTab, this.beforeTab];
    }

    selectTab(tabType: MigrationTabType): void {
        const target = this.tabTypeToTab[tabType] || null;

        if (target) {
            this.migrationTabs.forEach((t) => (t.selected = false));
            this.currentSelectedTab = target;
            this.currentSelectedTab.selected = true;
        }
    }

    set selectedTab(value: MyBetsMigrationTab) {
        if (value) {
            this.migrationTabs.forEach((t) => (t.selected = false));
            this.currentSelectedTab = value;
            this.currentSelectedTab.selected = true;
            this.tabSelected.emit(this.currentSelectedTab);
        }
    }

    get tabSelected(): EventEmitter<MyBetsMigrationTab> {
        return this._tabSelected;
    }
}
